/* import __COLOCATED_TEMPLATE__ from './step-preview.hbs'; */
import { classNameBindings, classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './step-preview.module.scss';

@classic
@classNames('step-preview', styles.component)
@classNameBindings('session.isMonarchEmbedded:step-preview-directory-iframe-color')
export default class RequestStepsStepPreview extends Component {
  @service session;
}
